import React, { useEffect, useState } from "react";
import UserProfile from "components/profile/UserProfile";
import { getUserProfile } from "services/UserManagementServices";
import "./profile.scss";
import { useProfilePicture } from "hooks/UserProfilePicture/UserProfilePicture";
import { useTranslation } from "react-i18next";
import ChangePassword from "components/ChangePassword";
const Profile = () => {
  const { t } = useTranslation();
  const { profileImage, setUserProfilePicture, isFetching } =
    useProfilePicture();
  const [profileData, setProfileData] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tabs, setTabs] = useState("Profil");

  const fetchProfile = async () => {
    setIsLoading(true);
    const result = await getUserProfile();
    if (result?.success) {
      setProfileData(result?.payLoad);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };
  useEffect(() => {
    fetchProfile();
  }, [refresh]);
  return (
    <>
      <div className="main mt-3">
        <div className="custom-breadcrumbs  ">
          <span className="breadcrumbs-item ml-3">Profile</span>
          <span className="breadcrumbs-item ">
            <p>{profileData?.firstName + " " + profileData?.lastName}</p>
          </span>
        </div>
        <div className="custom-tabs-container">
          <ul className="tabs-nav-custom text-uppercase">
            <li
              className={tabs === "Profil" ? "active" : ""}
              onClick={() => {
                setTabs("Profil");
              }}
            >
              {t("profile")}
            </li>
            <li
              className={tabs === "changePassword" ? "active" : ""}
              onClick={() => {
                setTabs("changePassword");
              }}
            >
              {t("changePassword")}
            </li>
          </ul>
          {tabs === "Profil" ? (
            <UserProfile
              isFetching={isLoading || isFetching ? true : false}
              profileData={profileData}
              handleRefresh={handleRefresh}
              profileImage={profileImage}
              setUserProfilePicture={setUserProfilePicture}
            />
          ) : (
            <>
              <ChangePassword setTabs={setTabs} />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Profile;
